import { render, staticRenderFns } from "./TaskHome.vue?vue&type=template&id=bcc2ac1e&scoped=true"
import script from "./TaskHome.vue?vue&type=script&lang=js"
export * from "./TaskHome.vue?vue&type=script&lang=js"
import style0 from "./TaskHome.vue?vue&type=style&index=0&id=bcc2ac1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc2ac1e",
  null
  
)

export default component.exports